import { TaskService } from '@weave/schema-gen-ts/dist/schemas/task-center/v1/task_service.pb';
import { bindHTTP } from '@frontend/schema';

export const SchemaTaskV1Service = bindHTTP(TaskService);
export const serviceName = 'task-v1' as const;
